import {logConfigLevels} from "./makeLogger"
import type {LogLevelConfig} from "./makeLogger"

export const getConfiguredLevel = (
  env: Record<string, string | undefined>,
  // eslint-disable-next-line no-console
  warn = console.warn.bind(console),
) => {
  // don't log in tests unless LOG_LEVEL_TEST is set
  const isTest = env.NODE_ENV === "test"

  // if LOG_LEVEL env is set, use that to filter logging
  const configuredLevel = isTest ? env.LOG_LEVEL_TEST : env.LOG_LEVEL
  const fallbackLevel = isTest ? "none" : "info"

  if (typeof configuredLevel === "undefined") return fallbackLevel
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (logConfigLevels.includes(configuredLevel as any))
    return configuredLevel as LogLevelConfig

  warn(
    `Logging configuration issue: unknown log level: "${configuredLevel}"; falling back to ${fallbackLevel}`,
  )
  return fallbackLevel
}
